export const BINOTEL_CONFIG = 'binotel_config';
export const NAVIGATION_SETTINGS_CONFIG = 'navigation_bar_config';
export const CLIENT_PERMISSIONS_CONFIG = 'client_permissions_config';
